"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/technical-documentation/technical-documentation/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("core-js/modules/es.string.trim-start.js");

require("core-js/modules/es.string.trim-end.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var codegen_1 = require("ajv/dist/compile/codegen");

var transform = {
  trimStart: function trimStart(s) {
    return s.trimStart();
  },
  trimEnd: function trimEnd(s) {
    return s.trimEnd();
  },
  trimLeft: function trimLeft(s) {
    return s.trimStart();
  },
  trimRight: function trimRight(s) {
    return s.trimEnd();
  },
  trim: function trim(s) {
    return s.trim();
  },
  toLowerCase: function toLowerCase(s) {
    return s.toLowerCase();
  },
  toUpperCase: function toUpperCase(s) {
    return s.toUpperCase();
  },
  toEnumCase: function toEnumCase(s, cfg) {
    return (cfg === null || cfg === void 0 ? void 0 : cfg.hash[configKey(s)]) || s;
  }
};
var getDef = Object.assign(_getDef, {
  transform: transform
});

function _getDef() {
  return {
    keyword: "transform",
    schemaType: "array",
    before: "enum",
    code: function code(cxt) {
      var gen = cxt.gen,
          data = cxt.data,
          schema = cxt.schema,
          parentSchema = cxt.parentSchema,
          it = cxt.it;
      var parentData = it.parentData,
          parentDataProperty = it.parentDataProperty;
      var tNames = schema;
      if (!tNames.length) return;
      var cfg;

      if (tNames.includes("toEnumCase")) {
        var config = getEnumCaseCfg(parentSchema);
        cfg = gen.scopeValue("obj", {
          ref: config,
          code: (0, codegen_1.stringify)(config)
        });
      }

      gen.if((0, codegen_1._)(_templateObject || (_templateObject = _taggedTemplateLiteral(["typeof ", " == \"string\" && ", " !== undefined"])), data, parentData), function () {
        gen.assign(data, transformExpr(tNames.slice()));
        gen.assign((0, codegen_1._)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", "[", "]"])), parentData, parentDataProperty), data);
      });

      function transformExpr(ts) {
        if (!ts.length) return data;
        var t = ts.pop();
        if (!(t in transform)) throw new Error("transform: unknown transformation ".concat(t));
        var func = gen.scopeValue("func", {
          ref: transform[t],
          code: (0, codegen_1._)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["require(\"ajv-keywords/dist/definitions/transform\").transform", ""])), (0, codegen_1.getProperty)(t))
        });
        var arg = transformExpr(ts);
        return cfg && t === "toEnumCase" ? (0, codegen_1._)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", "(", ", ", ")"])), func, arg, cfg) : (0, codegen_1._)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", "(", ")"])), func, arg);
      }
    },
    metaSchema: {
      type: "array",
      items: {
        type: "string",
        enum: Object.keys(transform)
      }
    }
  };
}

function getEnumCaseCfg(parentSchema) {
  // build hash table to enum values
  var cfg = {
    hash: {}
  }; // requires `enum` in the same schema as transform

  if (!parentSchema.enum) throw new Error('transform: "toEnumCase" requires "enum"');

  var _iterator = _createForOfIteratorHelper(parentSchema.enum),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var v = _step.value;
      if (typeof v !== "string") continue;
      var k = configKey(v); // requires all `enum` values have unique keys

      if (cfg.hash[k]) {
        throw new Error('transform: "toEnumCase" requires all lowercased "enum" values to be unique');
      }

      cfg.hash[k] = v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return cfg;
}

function configKey(s) {
  return s.toLowerCase();
}

exports.default = getDef;
module.exports = getDef;